module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAMCAYAAABFohwTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIBJREFUeNpiPKGlv5WBgcF/R1jgHyDNwATEXkCczgAFIIHXQNzssWq9IEygGIhBnC6wAFDvYiB9BogTgaqMmKBaI4CYGYh7YQKyUPoZI9BaPiDjFBDLAbEuC5DIAGJ1IK4GmncXpKUBiG8DcTvMWk6Q1UDZ/zCBPiBnM8ylAAEGAOLuHUv8Jw/PAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/arrow-next.png
// module id = 118
// module chunks = 0